/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { Component, OnInit,ElementRef,Input,AfterViewInit,Output, EventEmitter, ViewEncapsulation} from '@angular/core';
import { ControlBaseComponent } from "../control-base.component";
import { TimerService } from 'src/refresh/service/timer-service';

@Component({
  selector: 'ng-radio1',
  templateUrl: './radio1.component.html',
  styleUrls: ['./radio1.component.less']
  ,encapsulation: ViewEncapsulation.None
})
export class Radio1Component extends ControlBaseComponent implements OnInit,AfterViewInit {

      private static id_no:number = 1;
      private static id_name:number = 1;

      constructor( private elRef:ElementRef,protected timerService:TimerService) { 
            super(timerService,6);
      }

      @Input() value: string;

      public xid:string;

      public name:string;

      /**
      set input( value: any) {
            this._inputX = value;
            console.log('here');
      }
       */

      public get className():string {
             return this.class_name;
      }


      public get inputClass():string {
             return "on-radios__input " + this.input_class;
      }

      public get labelClass():string {
             return "on-radios__label " + this.label_class;
      }

      public ngOnInit(): void {
            
            if ( this.error ) {
                 throw new Error("in <ng-radio1>, [(ng-error)] is not support! use <errors [error].. with <ng-radio1 [ng-clear]");
            }

            //if ( this.className ) this.input_class = this.className + " " + this.input_class;
            //if ( this.styleName ) this.inputStyle  = this.styleName + " " + this.inputStyle;

            if ( this.input_class.indexOf("light-box") >= 0 ) {
                 if ( this.label_class ) this.label_class += " light-box";     
                 else                    this.label_class  = "light-box";     
            }
 

            let radioGroupDiv = this.elRef.nativeElement.querySelector('div');
            let parent = radioGroupDiv.parentElement.parentElement;

            let nameAttr = parent.getAttribute("name");

            if ( !nameAttr ) {
                  if ( parent.id ) {
                       nameAttr = parent.id;
                  }
                  else {
                        nameAttr = "_radio1_"+Radio1Component.id_name++;
                        parent.setAttribute("name",nameAttr);
                  }
            }

            this.name = nameAttr;

            if ( !this.id ) {
                  this.id =  "radio1_"+Radio1Component.id_no++;
                  this.xid  = nameAttr + "_" + this.value;
            }
            else  this.xid  = "radio_" + this.id;
            
            
                  
            super.errorParamSet();

            this.createDom();
      }
      
      public ngAfterViewInit() {

            let radioGroupDiv = this.elRef.nativeElement.querySelector('div');
            super.layoutFromViewInit(radioGroupDiv.parentElement);
             
      }

      private radioElem:any;
      private createDom()  {

            let holder = this.elRef.nativeElement.childNodes[0];
            let label  = holder.childNodes[0];
            this.radioElem = this.create();
            holder.insertBefore(this.radioElem,label);
     }

     @Input ('ng-model')  set input( valuex: any) {
              this._inputX = valuex;

              if ( this.radioElem ) {
                   if ( valuex === this.value ) {
                        this.radioElem.checked = true;
                   }
                   else this.radioElem.checked = false;
              }
   }

     get input() {
           return this._inputX;
     }


     private create(): any {

          let elem = document.createElement("input");
              elem.setAttribute("type","radio");
              elem.setAttribute("value",this.value);
              elem.setAttribute("name",this.name);
              elem.className = this.inputClass;
              elem.id = this.xid;

              if ( this.input === this.value ) {
                    elem.checked = true;
              }

              if ( this._disable ) {
                   elem.disabled = true;
              }

              if ( this.inputStyle ) {
                   elem.setAttribute("style",this.inputStyle);
              }

              elem.onclick =  ( () => {
                     if ( this.input !== this.value ) {
                          if ( typeof this.input == 'number' ) 
                               this.input = Number(this.value);
                          else this.input = this.value;
                          
                          super.valueChanged();
                     }
              });

          return elem;
     }
    

}
